// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"204":"6f6772bd","367":"048d14b2","379":"63d81490","472":"5c92d76a","633":"fc69e7b0","696":"fc69e7b0","835":"a203d108"}[chunkId] + ".css";
};